export const SET_SONG = "SET_SONG";
export const SET_QUEUE = "SET_QUEUE";
export const SET_ALL = "SET_ALL";
export const ADD = "ADD";
export const DELETE = "DELETE";
export const CLEAR = "CLEAR";
export const SET_SHUFFLE = "SET_SHUFFLE";
export const CLEAR_SHUFFLE = "CLEAR_SHUFFLE";
export const SET_REPEAT = "SET_REPEAT";
export const LIKE = "LIKE";
export const NEXT_SONG = "NEXT_SONG";
export const PREV_SONG = "PREV_SONG";
export const SET_LIST_POSITION = "SET_LIST_POSITION";
export const SET_PLAY_STATE = "SET_PLAY_STATE";
export const SET_VOLUME = "SET_VOLUME";
